import * as React from "react";
import { CommandBar } from "@fluentui/react/lib/CommandBar";
import { IButtonProps } from "@fluentui/react/lib/Button";
import { JemConfiguration } from "@jem/components";
import { css } from "@emotion/css";

const overflowProps: IButtonProps = { ariaLabel: "More Actions" };

import { ICommandBarItemProps } from "@fluentui/react";

export interface JemChecklistDashboardCommandBarItemsProps {
  openInNewTab: () => void;
  disabled?: boolean;
}

const JemChecklistDashboardCommandBarItems = (
  props: JemChecklistDashboardCommandBarItemsProps
): ICommandBarItemProps[] => {
  return [
    {
      key: "newChecklist",
      text: "New Checklist",
      cacheKey: "myCacheKey", // changing this key will invalidate this item's cache
      iconProps: { iconName: "Add" },
      onClick: () => props.openInNewTab(),
      disabled: props.disabled
    }
  ];
};

export const JEMChecklistDashboardCommandBar: React.FunctionComponent<{
  configuration: JemConfiguration["FCWNewJemChecklistLink"];
  IsFCCWIntegrationLive: boolean;
}> = (props) => {
  const openInNewTab = () => {
    window.open(props.configuration, "_blank", "noopener,noreferrer");
  };
  return (
    <div
      className={css`
        width: 100%;
        min-height: 1px;
        box-sizing: content-box;
        overflow: visible;
      `}
    >
      <CommandBar
        items={JemChecklistDashboardCommandBarItems({ openInNewTab, disabled: props.IsFCCWIntegrationLive })}
        styles={{
          root: {
            paddingLeft: 0
          }
        }}
        overflowButtonProps={overflowProps}
        ariaLabel="Inbox actions"
        primaryGroupAriaLabel="Email actions"
        farItemsGroupAriaLabel="More actions"
      />
    </div>
  );
};
